import React, { useState } from "react";
import { Image, Modal, Button } from "react-bootstrap";
import {
  ORDER_TYPE,
  PAYMENT_TYPE,
  PAYMENT_METHOD_STATUS,
} from "../../../enums/OrderEnums";

const offerType = [
  { id: 0, name: "All", value: 0 },
  { id: 1, name: "Online", value: 1 },
  { id: 2, name: "Offline", value: 2 },
];

const offerStatus = [
  { id: 0, name: "All", value: 0 },
  { id: 1, name: "Active", value: 1 },
  { id: 2, name: "Inactive", value: 2 },
];

const Filter = (props) => {
  const [state, setState] = useState({
    open: false,
  });
  const [orderType, setOrderType] = useState(false);
  const [paymentType, setPaymentType] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [orderTypeText, setOrderTypeText] = useState(0);
  const [paymentTypeText, setPaymentTypeText] = useState(0);
  const [paymentStatusText, setPaymentStatusText] = useState();

  const onOpenModal = () => {
    setState({ open: true });
  };
  const handleCloseModal = () => {
    setState({ open: false });
  };

  const onClickOfferType = (id) => {
    setOrderTypeText(id);
  };
  const onClickStatusType = (data) => {
    setPaymentTypeText(data);
  };
  const onClickPaymentStatus = (data) => {
    setPaymentStatusText(data);
  };

  const onClickResetFilter = () => {
    setOrderTypeText(0);
    setPaymentTypeText(0);
    // setPaymentStatusText("");
    setOrderType(false);
    setPaymentType(false);
    // setPaymentStatus(false);
    props.orderTypeData(0);
    props.paymentTypeData(0);
    // props.paymentStatusData("");
    handleCloseModal();
  };

  const onClickApplyFilter = () => {
    props.orderTypeData(orderTypeText);
    props.paymentTypeData(paymentTypeText);
    // props.paymentStatusData(paymentStatusText);
    setOrderType(false);
    setPaymentType(false);
    // setPaymentStatus(false);
    handleCloseModal();
  };

  const [filterType, setFilter] = useState(0);

  return (
    <React.Fragment>
      <div
        onClick={onOpenModal}
        className="d-flex align-items-center justify-content-between cursor"
      >
        <Image
            alt="filter"
            title="filter"
            width="80px"
            src={require("../../../assets/images/seatingImages/filter.svg")}
          />
        {/* <div className="f12-500 text-blue mx-2">Filter</div>
        <i className="fa fa-angle-down text-blue" aria-hidden="true"></i> */}
      </div>
      <Modal show={state.open} onHide={handleCloseModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center pb-4 ">
            <label className="enRadioWithText f12-500 mr-4">
              {props.displayBy} Type
              <input
                type="radio"
                name="CouponDiscountType"
                checked={filterType === 0 ? true : false}
                onChange={() => {
                  setFilter(0);
                }}
              />
              <span className="checkmark"></span>
            </label>
            <label className="enRadioWithText f12-500 mr-4">
              Status
              <input
                type="radio"
                name="CouponDiscountType"
                checked={filterType === 1 ? true : false}
                onChange={() => {
                  setFilter(1);
                }}
              />
              <span className="checkmark"></span>
            </label>
            {/* <label className="enRadioWithText f12-500 mr-4">
              Payment Status
              <input
                type="radio"
                name="CouponDiscountType"
                checked={paymentStatus}
                onChange={() => {
                  setOrderType(false);
                  setPaymentType(false);
                  setPaymentStatus(true);
                }}
              />
              <span className="checkmark"></span>
            </label> */}
          </div>
          <div className="f16-500 pb-4">
            Select one relevant option from below
          </div>
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            {filterType === 0
              ? offerType.map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className="enCheckWithText mr-3"
                        onClick={() => onClickOfferType(data.value)}
                      >
                        <input type="radio" name="OfferType" />
                        <label
                          style={{
                            borderColor: `${
                              orderTypeText === data.value ? "#ee3a23" : ""
                            }`,
                          }}
                        >
                          {data.name}
                        </label>
                      </div>
                    </React.Fragment>
                  );
                })
              : null}
          </div>
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            {filterType === 1
              ? offerStatus.map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className="enCheckWithText mr-3"
                        onClick={() => onClickStatusType(data.value)}
                      >
                        <input type="radio" name="OfferType" />
                        <label
                          style={{
                            borderColor: `${
                              paymentTypeText === data.value ? "#ee3a23" : ""
                            }`,
                          }}
                        >
                          {data.name}
                        </label>
                      </div>
                    </React.Fragment>
                  );
                })
              : null}
          </div>
          {/* <div className="d-flex flex-wrap align-items-center justify-content-between">
            {paymentStatus && paymentStatus === true
              ? PAYMENT_METHOD_STATUS.map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className="enCheckWithText mr-3"
                        onClick={() => onClickPaymentStatus(index)}
                      >
                        <input type="radio" name="OfferType" />
                        <label>{data}</label>
                      </div>
                    </React.Fragment>
                  );
                })
              : null}
          </div> */}
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={onClickResetFilter}
            >
              Reset Filter
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={onClickApplyFilter}
            >
              Apply Filter
            </Button>
          </Modal.Footer>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default Filter;
